import { useHistory } from 'react-router-dom';
import { usePageTitle } from 'shared/lib/title';
import { Roles, useClientDataStore } from 'shared/lib/store';
import { AppLoader } from 'app/AppLoader';
import { useEffect } from 'react';
import { ShareList } from 'shared/lib/share';
import { pageRoutes } from 'shared/routes';
import {
  useGetContractorArchivedInvoicePdf,
  useGetContractorCurrentInvoicePdf,
  useGetManagerArchivedInvoicePdf,
  useGetManagerCurrentInvoicePdf,
} from 'entities/invoice';
import { logError } from 'shared/lib/log-errors';
import { showDownloadToast } from 'shared/lib/notifications';

export function Share() {
  usePageTitle('Share');

  const history = useHistory();
  const searchParams = new URLSearchParams(history.location.search);

  const { getRole } = useClientDataStore();
  const role = getRole();

  const invoice_current_id = Number(searchParams.get(ShareList.INVOICE_CURRENT) ?? '0');
  const invoice_archived_id = Number(searchParams.get(ShareList.INVOICE_ARCHIVED) ?? '0');

  const useGetManagerCurrentInvoicePdfQuery = useGetManagerCurrentInvoicePdf(invoice_current_id);
  const useGetManagerArchivedInvoicePdfQuery = useGetManagerArchivedInvoicePdf(invoice_archived_id);
  const useGetContractorCurrentInvoicePdfQuery = useGetContractorCurrentInvoicePdf(invoice_current_id);
  const useGetContractorArchivedInvoicePdfQuery = useGetContractorArchivedInvoicePdf(invoice_archived_id);

  const handleInvoiceShare = (
    page: string,
    openFn: { download: () => Promise<unknown>; openInNewWindow: () => Promise<unknown> }
  ) => {
    history.push(page);
    showDownloadToast(`Invoice download will start automatically in a few seconds.`, () =>
      openFn.download().catch(logError)
    );
    openFn.download().catch(logError);
  };

  useEffect(() => {
    if (role === Roles.Manager && searchParams.has(ShareList.INVOICE_CURRENT)) {
      handleInvoiceShare(pageRoutes.internal.invoices, useGetManagerCurrentInvoicePdfQuery);

      return;
    }

    if (role === Roles.Manager && searchParams.has(ShareList.INVOICE_ARCHIVED)) {
      handleInvoiceShare(`${pageRoutes.internal.invoices}?tabId=1`, useGetManagerArchivedInvoicePdfQuery);

      return;
    }

    if (role === Roles.Contractor && searchParams.has(ShareList.INVOICE_CURRENT)) {
      handleInvoiceShare(pageRoutes.app.billing, useGetContractorCurrentInvoicePdfQuery);

      return;
    }

    if (role === Roles.Contractor && searchParams.has(ShareList.INVOICE_ARCHIVED)) {
      handleInvoiceShare(`${pageRoutes.app.billing}?tabId=1`, useGetContractorArchivedInvoicePdfQuery);

      return;
    }

    history.push(pageRoutes.app.main);
  }, [searchParams]);

  return <AppLoader />;
}
